import React, { useEffect, useRef, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";

const INTERVALO_MS = 6000;

const formatoFecha = (fecha) =>
  fecha
    ? new Date(fecha).toLocaleDateString("es-MX", { day: "2-digit", month: "short", timeZone: "UTC" })
    : "";

export default function Eventos() {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [indice, setIndice] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await fetch("/api/eventos/vigentes", {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Error obteniendo eventos");
        setEventos(await res.json());
      } catch (err) {
        console.error("Error cargando eventos:", err);
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, []);

  useEffect(() => {
    if (eventos.length <= 1) return;
    timerRef.current = setInterval(() => {
      setIndice((prev) => (prev + 1) % eventos.length);
    }, INTERVALO_MS);
    return () => clearInterval(timerRef.current);
  }, [eventos.length]);

  const actual = eventos[indice];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <h2 className="text-base font-semibold text-slate-800 mb-4">
        Próximos Eventos
      </h2>

      {loading ? (
        <p className="text-sm text-slate-400 text-center py-10">Cargando eventos...</p>
      ) : eventos.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-10">No hay eventos próximos por el momento.</p>
      ) : (
        <div>
          <div className="relative w-full h-64 rounded-lg overflow-hidden bg-slate-100">
            {actual.imagen ? (
              <img
                key={actual.id_evento}
                src={`${actual.imagen}`}
                alt={actual.titulo}
                className="w-full h-full object-contain animate-fadeIn"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <FaCalendarAlt className="text-4xl text-slate-300" />
              </div>
            )}

            <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-slate-900/80 to-transparent px-4 pt-8 pb-3 text-white">
              <p className="text-sm font-semibold">{actual.titulo}</p>
              <p className="text-xs text-slate-200">
                {formatoFecha(actual.fecha_inicio)} — {formatoFecha(actual.fecha_fin)}
              </p>
            </div>
          </div>

          {actual.descripcion && (
            <p className="text-xs text-slate-500 mt-3">{actual.descripcion}</p>
          )}

          {eventos.length > 1 && (
            <div className="flex justify-center gap-1.5 mt-3">
              {eventos.map((ev, i) => (
                <button
                  key={ev.id_evento}
                  onClick={() => setIndice(i)}
                  aria-label={`Ver ${ev.titulo}`}
                  className={`h-1.5 rounded-full transition-all ${
                    i === indice ? "w-5 bg-indigo-600" : "w-1.5 bg-slate-200 hover:bg-slate-300"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
